export default __webpack_public_path__ + "media/images/open-graph-image-f861e65fde39aa1c54ba5bf1368b678c.jpg";